import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer, Navigate } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { CustomPostAPI } from "../Utils/APIConnector";
import VenueOwnerDetailsPopup from "../Popup/VenueOwnerDetailsPopup";
import VenueOwnerOfflineBooking from "../Popup/VenueOwnerOfflineBooking";
import { formatDateToInput } from "../Utils/common";
import Loader from "../Utils/Loader";
moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default function VenueCalender({
  VenueId,
  selectedDate,
  setSelectedDate,
  activeCourtID,
  getSlotdata,
}) {
  // const formatEvents = (events) => {
  //   return events.map((event) => ({
  //     start: new Date(event.start), // Ensure this is a Date object
  //     end: new Date(event.end), // Ensure this is a Date object
  //     title: event.title,
  //     username: event.username,
  //     userPhone: event.userPhone,
  //     // Add any other properties you want to keep
  //   }));
  // };
  const [Events, setEvents] = useState([]);
  // const [activeButton, setActiveButton] = useState();
  const [isLoading, setIsLoading] = useState(true);
  // const [surfaces, setSurfaces] = useState();
  const [show, setShow] = useState({ popup: false, data: "", title: "" });
  const [showoffline, setShowoffline] = useState({
    popup: false,
    data: "",
    title: "",
    date: "",
  });
  const windowWidth = window.innerWidth;
  const [CalenderSelectedDate, setCalenderSelectedDate] =
    useState(selectedDate);
  useEffect(() => {
    setCalenderSelectedDate(selectedDate);
  }, [selectedDate]);
  useEffect(() => {
    // const raw = JSON.stringify({
    //   VenueId: VenueId,
    //   venuecourtid: activeCourtID ? null : null,
    // });
    // CustomPostAPI("/Venue/GetBookedvenueCalendar", raw).then((result) => {
    //   if (result === undefined || result === "") {
    //     alert("Something went wrong");
    //   } else {
    //     result = JSON.parse(result);
    //     const transformedEvents = result.bookingDetails.map((event) => ({
    //       ...event,
    //       start: new Date(event.start),
    //       end: new Date(event.end),
    //     }));
    //     setEvents(transformedEvents);
    //     setSurfaces(result?.surfaceDetails);
    //     setActiveButton(result?.surfaceDetails[0]?.name);
    //   }
    // });
    getdata(activeCourtID)
  }, [activeCourtID]);
  const getdata = async (id, date = CalenderSelectedDate) => {
    setIsLoading(true);
    try {
      const raw = JSON.stringify({
        VenueId: VenueId,
        venuecourtid: id ? id : null,
        Date: date,
      });

      const result = await CustomPostAPI("/Venue/GetBookedvenueCalendar", raw);

      if (!result) {
        alert("Something went wrong");
      } else {
        const parsed = JSON.parse(result);
        const transformedEvents = parsed.bookingDetails.map((event) => ({
          ...event,
          start: new Date(event.start),
          end: new Date(event.end),
        }));
        setEvents(transformedEvents);
        // setSurfaces(parsed?.surfaceDetails);
        // setActiveButton(parsed?.surfaceDetails[0]?.name);
      }
    } catch (error) {
      console.log(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <>
        {isLoading ? <Loader /> : <div className="myCustomHeight p-3">
          <Calendar
            date={CalenderSelectedDate}
            onNavigate={(date) => {
              // setCalenderSelectedDate(date);
              setSelectedDate(date);
              getdata(activeCourtID, date)
            }}
            // views={["month", "day", "agenda", "work_week"]}
            views={["month"]}
            selectable
            startAccessor="start"
            endAccessor="end"
            localizer={localizer}
            defaultDate={new Date()}
            defaultView={"month"}
            events={Events}
            style={{ height: "75vh" }}
            popup={true}
            showMultiDayTimes={true}
            onSelectEvent={(event) =>
              setShow({ popup: true, data: event, title: "Booking Details" })
            }

          // onSelectSlot={(slot) => {
          //   setShowoffline({
          //     date: slot?.start,
          //     popup: true,
          //     data: slot,
          //     title: "Book Your Venue Offline",
          //   });
          // }}
          />
        </div>}
      </>
      <VenueOwnerDetailsPopup
        show={show}
        setShow={setShow}
        getdata={getSlotdata}
        getCalData={getdata}
      />
      <VenueOwnerOfflineBooking
        showoffline={showoffline}
        setShowoffline={setShowoffline}
        VenueId={VenueId}
      />
    </React.Fragment>
  );
}
